import { TimelineEntityMeta } from "store/apis/filingsTimeline";

export type TimelineYearBounds = {
  minYear: number;
  maxYear: number;
};

/**
 * The arrows span every year the group has something to show. Incorporation is
 * the usual floor, but a filing can predate it — a late return for a year the
 * entity was not yet on record, say — so the earliest filing year wins when it
 * is older. Anything the API returns has to be reachable.
 */
export const getTimelineYearBounds = (
  entities: TimelineEntityMeta[]
): TimelineYearBounds | null => {
  if (entities.length === 0) return null;

  const filingYears = entities.flatMap((entity) =>
    entity.year_stats.map((stat) => stat.year)
  );

  const incorporationYears = entities.map(
    (entity) => entity.incorporation_year
  );

  return {
    minYear: Math.min(...incorporationYears, ...filingYears),
    maxYear: Math.max(...incorporationYears, ...filingYears),
  };
};
